module.exports = __webpack_public_path__ + "static/media/8KCAB.071617c4.png";